import { mapEnumToOptions } from '@abp/ng.core';

export enum MotiveType {
  Approval = 0,
  Refusal = 1,
}

export const motiveTypeOptions = mapEnumToOptions(MotiveType);
